export default () => window.documentViewer.getDocument().isWebViewerServerDocument();